module.exports = __webpack_public_path__ + "static/features-1.5f62218d.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/features-1.png
// module id = 232
// module chunks = 0